export const RETURN_ITEM_REASONS = strings => ({
  invalid: strings.invalid,
  unsold: strings.unsold,
  damaged: strings.damaged,
  quality: strings.quality
})
